import { Shark, View } from "shark-mvc";

import Person from "../../_shark_models/Person";

import templateContent from "./client-edit.html";

import clientListView from "./clientListView";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import clientSolvencyRequestManager from "../../controllers/clientSolvencyRequestManager";
import ClientSolvencyRequest from "../../_shark_models/ClientSolvencyRequest";
import clientSolvencyRequestModalComponent from "../../components/clientSolvencyRequestModal/clientSolvencyRequestModalComponent";

class ClientEditView extends View {
	constructor(name) {
		super(name);

		this.setTemplate(templateContent);
	}

	addPersonBtn_clickHandler () {
		const { editingClient } = Shark.get();

		const newPerson = new Person();
		editingClient.addPerson(newPerson);
		Shark.render();
	}

	afterRender () {
		const sectorSelect = document.querySelector(`[data-sh-prop="sector"]`);

		if (sectorSelect) {
			sectorSelect.querySelector(`[value="Geodrena"]`) ? sectorSelect.querySelector(`[value="Geodrena"]`).disabled = true : false;
			sectorSelect.querySelector(`[value="Green Paving"]`) ? sectorSelect.querySelector(`[value="Green Paving"]`).disabled = true : false;
		}
	}

	refreshList () {
		this.getClientList();
	}

	
	refreshClientSolvencyRequestList () {
		const { editingClient: currClient } = Shark.get();

		if (currClient) {
			clientSolvencyRequestManager.getListByContactGuid(currClient.guid)
			.then(getListResponse => {
				console.log({getListResponse});

				const clientSolvencyRequestList = Shark.getInstanceList(ClientSolvencyRequest, getListResponse.data);

				Shark.set({
					clientSolvencyRequestList,
				});
			});
		}
	}

	removePersonBtn_clickHandler (event, data) {
		const { editingClient: currClient } = Shark.get();
		const person = currClient.people[data.index];

		if (confirm(`Vuoi davvero eliminare '${person.firstName} ${person.lastName}' da questa scheda?\nSe continui non sarà possibile annullare l'operazione!`)) {
			currClient.removePerson(data.index);
			Shark.render();
		}
	}




	
	backToClientListBtn_clickHandler () {
		Shark.openPage(clientListView);
	}

	beforeLoad () {
		const editingClient = Shark.get("editingClient");

		if (editingClient) {
			siteInfoSheetManager.getListByClient(Shark.get("editingClient"));
		}

		if (!Shark.get("agentList")) {
			userManager.getList();
		}
		window.scrollTo(0, 0);

		this.refreshClientSolvencyRequestList();

		clientSolvencyRequestModalComponent.set({
			referenceType: "contact",
		});
	}

	cancelEditsBtn_clickHandler () {
		const editingClient = Shark.get("editingClient");

		if (!editingClient.isDirty() || (editingClient.isDirty() && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
			editingClient.restore();

			if (Shark.get("isNewClient")) {
				Shark.set("isNewClient", false);
				Shark.openPage(clientListView);
			}
			else {
				Shark.set("__isEditing", false);
				// Shark.render();
			}
		}
	}

	clientManager_clientSavedHandler () {
		Shark.set("__isEditing", false);
	}

	editClientBtn_clickHandler () {
		Shark.set("__isEditing", true);
	}

	init () {
		this.addComponents([clientSolvencyRequestModalComponent, followUpComponent, mainNavComponent]);

		Shark.set({
			clientSolvencyRequestList: Shark.get("clientSolvencyRequestList") || [],
			__isEditing: false,
		});
	}

	clientSourceField_changeHandler () {
		const clientSourceField = document.querySelector("#clientSourceField");
		const clientFairSourceBox = document.querySelector("#clientFairSourceBox");

		if (clientSourceField) {
			if (parseInt(clientSourceField.value) === 2) {
				clientFairSourceBox.classList.add("d-block");
				clientFairSourceBox.classList.remove("d-none");
			}
			else {
				clientFairSourceBox.classList.remove("d-block");
				clientFairSourceBox.classList.add("d-none");
			}
		}
	}

	saveClientBtn_clickHandler () {
		const editingClient = Shark.get("editingClient");
		//Dave.ToDo: Spostiamo anche il salvataggio nel componente
		const currFollowUp = Shark.get("currFollowUp");

		if (currFollowUp) {
			if (currFollowUp.isDirty()) {
				// editingClient.addFollowUp(currFollowUp);
				followUpManager.save(currFollowUp);
			}
		}
		clientManager.save(editingClient);
	}

	// siteInfoSheetManager_listChangedHandler () {
	// 	this.set({
	// 		siteInfoSheetList: Shark.get("siteInfoSheetList")
	// 	});
	// });

	userManager_listChangedHandler () {
		this.set({
			agentList: Shark.get("agentList")
		});
	}

}

const clientEditView = new ClientEditView("clientEditView");

Shark.registerView(clientEditView);

export default clientEditView;
